module.exports = __webpack_public_path__ + "storeCode.0fed543fc7e8732640bab3816e1e26a7.csv";